import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import { confirmable } from 'react-confirm';

const ConfirmModal = (props) => (
  <Modal
    isOpen={props.show}
    toggle={props.dismiss}
    backdrop={props.enableEscape ? true : 'static'}
    keyboard={props.enableEscape}
  >
    <ModalHeader toggle={props.dismiss}>{props.title}</ModalHeader>
    <ModalBody>{props.confirmation}</ModalBody>

    <ModalFooter>
      {props.cancelLabel !== 'null' && (
        <Button onClick={props.dismiss}>{props.cancelLabel}</Button>
      )}
      <Button color="primary" onClick={props.proceed}>
        {props.okLabel}
      </Button>
    </ModalFooter>
  </Modal>
);

ConfirmModal.propTypes = {
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  title: PropTypes.string,
  confirmation: PropTypes.any,
  show: PropTypes.bool,
  proceed: PropTypes.func, // called when ok button is clicked.
  cancel: PropTypes.func, // called when cancel button is clicked.
  dismiss: PropTypes.func, // called when backdrop is clicked or escaped.
  enableEscape: PropTypes.bool,
};

ConfirmModal.defaultProps = {
  okLabel: 'OK',
  cancelLabel: 'Cancel',
  enableEscape: true,
};

export default confirmable(ConfirmModal);
